import React from 'react'
import { Card, Button, Space, Typography, Tag, Alert } from 'antd'
import { UserOutlined, TeamOutlined } from '@ant-design/icons'
import { getStatusBadge, calculateTimeInfo } from '../utils/formatters'
import ProcedureProgress from './ProcedureProgress'
import NextProcedure from './NextProcedure'

const { Text } = Typography

const TheatreCard = ({ theatre }) => {
  // Calculate time info using our fixed reference date
  const timeInfo = calculateTimeInfo(theatre.startTime, theatre.estimatedEndTime)

  return (
    <Card
      title={
        <Space>
          {theatre.theatreRoom}
          {getStatusBadge(theatre.status)}
        </Space>
      }
      extra={
        <Button type='link' size='small'>
          Details
        </Button>
      }
      style={{ marginBottom: '16px', height: '100%' }}
      className='theatre-card'
    >
      {theatre.status === 'Active' && (
        <>
          <ProcedureProgress
            theatre={theatre}
            elapsed={timeInfo.elapsed}
            remaining={timeInfo.remaining}
            progress={timeInfo.progress}
          />

          <div style={{ marginBottom: '8px' }}>
            <Space>
              <UserOutlined />
              <Text>Patient: </Text>
              <Text strong>{theatre.patientName}</Text>
              <Tag color='blue'>{theatre.patientId}</Tag>
            </Space>
          </div>
          <div style={{ marginBottom: '8px' }}>
            <Space>
              <TeamOutlined />
              <Text>Surgeon: </Text>
              <Text strong>{theatre.surgeonName}</Text>
            </Space>
          </div>
        </>
      )}

      {theatre.status === 'Cleaning' && (
        <Alert
          message='Cleaning in Progress'
          description={theatre.notes || 'Theatre cleaning in progress.'}
          type='warning'
          showIcon
          style={{ marginBottom: '16px' }}
        />
      )}

      {theatre.alerts && theatre.alerts.length > 0 && (
        <Alert
          message='Theatre Alerts'
          description={
            <ul style={{ paddingLeft: '20px', margin: 0 }}>
              {theatre.alerts.map((alert, idx) => (
                <li key={idx}>{alert}</li>
              ))}
            </ul>
          }
          type='error'
          showIcon
          style={{ marginBottom: '16px' }}
        />
      )}

      <NextProcedure theatre={theatre} />
    </Card>
  )
}

export default TheatreCard
